import { ExportType } from "@syncfusion/ej2-react-charts";

export class Helper
{
    public static exportTypes: ExportType[] = ['PNG', 'CSV'];
}
